import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';

import './styles/tailwind.css';
import store from './store/';
import AppErrorBoundary from './components/AppErrorBoundary';
import App from './containers/app';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  release: `${process.env.REACT_APP_SENTRY_PROJECT}@${process.env.REACT_APP_SENTRY_VERSION}`,
  environment: process.env.NODE_ENV,
});

ReactDOM.render(
  <Provider store={store}>
    <AppErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppErrorBoundary>
  </Provider>,
  document.getElementById('root'),
);
